import { useCart } from "../context/CartContext";

const CartCountBadge = ({ className = "" }) => {
  const { cartCount } = useCart();

  if (!cartCount) return null;

  return (
    <span className={`cart-count-badge ${className}`.trim()}>
      {cartCount > 99 ? "99+" : cartCount}
    </span>
  );
};

export default CartCountBadge;
